import {
  TaxEstimateFilingStatus,
  UsTaxState
} from "@wingspanhq/wingspan-api-sdk";
import { US_STATES_OPTIONS } from "../../constants/user";

/**
 * Filing-status options for the tax-profile form.
 *
 * v1 stored a `TaxFilingCode` ("S"/"M"/"H"/"MS"/"QW") on the member profile; v3
 * stores the SDK enum on the tax-withholding settings, so the form speaks it
 * directly and there is no code to map.
 */
export const FILING_STATUS_OPTIONS = [
  {
    value: TaxEstimateFilingStatus.SINGLE,
    label: "Single"
  },
  {
    value: TaxEstimateFilingStatus.MARRIED_FILING_JOINTLY,
    label: "Married filing jointly"
  },
  {
    value: TaxEstimateFilingStatus.MARRIED_FILING_SEPARATELY,
    label: "Married filing separately"
  },
  {
    value: TaxEstimateFilingStatus.HEAD_OF_HOUSEHOLD,
    label: "Head of household"
  },
  {
    value: TaxEstimateFilingStatus.QUALIFYING_SURVIVING_SPOUSE,
    label: "Qualifying surviving spouse"
  }
];

const US_TAX_STATES = new Set<string>(Object.values(UsTaxState));

/**
 * State-of-residence options the tax profile accepts. `UsTaxState` covers the 50
 * states plus DC; the shared `US_STATES_OPTIONS` also carries the territories
 * (PR, GU, VI, AS, MP, MU), which the settings endpoint rejects.
 */
export const US_TAX_STATE_OPTIONS = US_STATES_OPTIONS.filter(option =>
  US_TAX_STATES.has(option.value)
);
